export const UPDATE_SELF_BILLING_INVOICE_STATUS = gql`
    mutation updateSelfBillingInvoiceStatus($id: ID!) {
        updateSelfBillingInvoiceStatus(id: $id) {
            id
            status
        }
    }
`;

export const RESEND_SELF_BILLING_INVOICE = gql`
    mutation resendSelfBillingInvoice($input: ResendSelfBillingInvoiceInput) {
        resendSelfBillingInvoice(input: $input) {
            id
            status
        }
    }
`;
